import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  div {
    max-height: 20rem !important;
  }
`;

export const InputLabel = styled.span`
  font-family:
    Circular Std,
    sans-serif;
  font-size: 1rem;
  font-weight: 300;
  margin-top: 1.2rem;
  margin-bottom: 0.75rem;
  color: ${({ theme }) => theme.colors.blackboard.main};
`;
